export default __webpack_public_path__ + "static/media/background.10ae2daf.jpg";